import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { supabase } from '../services/supabaseClient'

function levelLabel(level) {
  if (level === 'prekg') return 'مرحلة الحضانة'
  if (level === 'kg1') return 'صف الروضة (الأول)'
  if (level === 'kg2') return 'صف التمهيدي (الثاني)'
  return level || '—'
}

export default function Dashboard() {
  const { user, signOut } = useAuth()
  const email = user?.email || ''
  const [checkingLink, setCheckingLink] = useState(true)
  const [kid, setKid] = useState(null)
  const [todayLoading, setTodayLoading] = useState(false)
  const [todayError, setTodayError] = useState('')
  const [attendanceSummary, setAttendanceSummary] = useState(null)
  const navigate = useNavigate()

  useEffect(() => {
    let active = true
    ;(async () => {
      const { data, error } = await supabase.rpc('get_current_kg_kid')
      if (!active) return
      if (error) {
        setCheckingLink(false)
        return
      }
      if (!data || data.length === 0) {
        navigate('/link-account', { replace: true })
        return
      }
      setKid(data[0])
      setCheckingLink(false)
    })()
    return () => { active = false }
  }, [navigate])

  useEffect(() => {
    if (checkingLink || !kid) return
    let active = true
    ;(async () => {
      setTodayLoading(true)
      setTodayError('')
      setAttendanceSummary(null)
      try {
        const today = new Date()
        const todayStr = today.toISOString().slice(0, 10)

        const { data, error } = await supabase.rpc('get_kg_kid_attendance', {
          p_from: todayStr,
          p_to: todayStr,
        })
        if (!active) return
        if (error) throw error

        const rows = data || []
        if (rows.length > 0) {
          const statuses = rows.map(r => r.status).filter(Boolean)
          let label = ''
          if (statuses.includes('absent')) label = 'غياب'
          else if (statuses.includes('late')) label = 'متأخر'
          else if (statuses.includes('excused')) label = 'مُعذَر'
          else if (statuses.includes('present')) label = 'حاضر'
          setAttendanceSummary(label ? { label } : null)
        } else {
          setAttendanceSummary(null)
        }
      } catch (err) {
        if (!active) return
        setTodayError(err.message || 'تعذر تحميل بيانات اليوم')
      } finally {
        if (!active) return
        setTodayLoading(false)
      }
    })()
    return () => { active = false }
  }, [checkingLink, kid])

  return (
    <div
      dir="rtl"
      style={{
        minHeight: '100vh',
        backgroundColor: '#f3f4f6',
        padding: '1.5rem',
      }}
    >
      {checkingLink ? (
        <div style={{ maxWidth: 720, margin: '0 auto', textAlign: 'center', marginTop: '4rem' }}>
          <div
            style={{
              backgroundColor: '#ffffff',
              borderRadius: 16,
              padding: 24,
              boxShadow: '0 10px 25px rgba(15,23,42,0.08)',
            }}
          >
            <p style={{ margin: 0 }}>جاري التحقق من ربط الحساب بالطفل المناسب...</p>
          </div>
        </div>
      ) : (
        <div style={{ maxWidth: 720, margin: '0 auto' }}>
          <div
            style={{
              backgroundColor: '#ffffff',
              borderRadius: 16,
              padding: 16,
              boxShadow: '0 10px 25px rgba(15,23,42,0.08)',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <h1 style={{ margin: 0 }}>بوابة رياض الأطفال</h1>
                <p style={{ margin: '4px 0', color: '#6b7280', fontSize: 14 }}>
                  متابعة حضور الطفل في مرحلة رياض الأطفال من خلال بوابة بسيطة للأهل.
                </p>
              </div>
              <button
                type="button"
                onClick={signOut}
                style={{
                  padding: '6px 10px',
                  borderRadius: 999,
                  border: '1px solid #e5e7eb',
                  background: '#f9fafb',
                  cursor: 'pointer',
                  fontSize: 13,
                }}
              >
                تسجيل الخروج
              </button>
            </div>

            <div style={{ marginTop: 12, marginBottom: 12 }}>
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                <button
                  type="button"
                  disabled
                  style={{
                    padding: '6px 10px',
                    borderRadius: 999,
                    border: '1px solid #2563eb',
                    background: '#2563eb',
                    color: '#fff',
                    cursor: 'default',
                    fontSize: 13,
                  }}
                >
                  لوحة المعلومات
                </button>
                <button
                  type="button"
                  onClick={() => navigate('/attendance')}
                  style={{
                    padding: '6px 10px',
                    borderRadius: 999,
                    border: '1px solid #e5e7eb',
                    background: '#fff',
                    cursor: 'pointer',
                    fontSize: 13,
                  }}
                >
                  الحضور
                </button>
                <button
                  type="button"
                  onClick={() => navigate('/daily-plan')}
                  style={{
                    padding: '6px 10px',
                    borderRadius: 999,
                    border: '1px solid #e5e7eb',
                    background: '#fff',
                    cursor: 'pointer',
                    fontSize: 13,
                  }}
                >
                  خطة اليوم
                </button>
                <button
                  type="button"
                  onClick={() => navigate('/assessment')}
                  style={{
                    padding: '6px 10px',
                    borderRadius: 999,
                    border: '1px solid #e5e7eb',
                    background: '#fff',
                    cursor: 'pointer',
                    fontSize: 13,
                  }}
                >
                  التقييم
                </button>
                <button
                  type="button"
                  onClick={() => navigate('/fees')}
                  style={{
                    padding: '6px 10px',
                    borderRadius: 999,
                    border: '1px solid #e5e7eb',
                    background: '#fff',
                    cursor: 'pointer',
                    fontSize: 13,
                  }}
                >
                  الرسوم
                </button>
                <button
                  type="button"
                  onClick={() => navigate('/assessment')}
                  style={{
                    padding: '6px 10px',
                    borderRadius: 999,
                    border: '1px solid #e5e7eb',
                    background: '#fff',
                    cursor: 'pointer',
                    fontSize: 13,
                  }}
                >
                  التقييم
                </button>
              </div>
            </div>

            <div
              style={{
                marginBottom: 16,
                padding: 12,
                borderRadius: 12,
                background: '#f9fafb',
                border: '1px solid #e5e7eb',
              }}
            >
              <p style={{ marginBottom: 6 }}>مرحباً بك في بوابة رياض الأطفال.</p>
              {kid && (
                <p style={{ marginBottom: 4 }}>
                  الطفل/ة: <strong>{kid.name}</strong> (رمز: {kid.code})
                  {kid.level && (
                    <>
                      {' '}
                      - المرحلة: <strong>{levelLabel(kid.level)}</strong>
                    </>
                  )}
                </p>
              )}
              {email && (
                <p style={{ marginBottom: 0 }}>
                  تم تسجيل الدخول بالبريد: <strong>{email}</strong>
                </p>
              )}
            </div>

            <div
              style={{
                marginBottom: 16,
                padding: 12,
                borderRadius: 12,
                background: '#eff6ff',
                border: '1px solid #dbeafe',
              }}
            >
              <h2 style={{ margin: '0 0 8px', fontSize: 16 }}>اليوم في لمحة</h2>
              {todayLoading ? (
                <div style={{ fontSize: 14 }}>جارٍ تحميل بيانات اليوم...</div>
              ) : todayError ? (
                <div style={{ fontSize: 13, color: '#b91c1c' }}>{todayError}</div>
              ) : (
                <ul style={{ listStyle: 'none', margin: 0, padding: 0, fontSize: 14 }}>
                  <li>
                    <strong>الحضور:</strong>{' '}
                    {attendanceSummary
                      ? attendanceSummary.label
                      : 'لا يوجد تسجيل حضور لليوم بعد.'}
                  </li>
                </ul>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
